// /services/phpApiService.ts

import axios from "axios";
// import { Data } from "./components/userlist/Userlist";

const BASE_URL = "https://boxerfjaes.dk/datasources/api/";

export interface Users {
  id: number;
  userName: string;
  password: string;
  email: string;
  name: string;
  creationDate: Date;
  lastLogin: Date;
  role: string;
  status: string;
  obsolete: boolean;
}

export default class PhpApiService {
  async getData(): Promise<Users[]> {
    try {
      const response = await axios.get<Users[]>(`${BASE_URL}getData.php`);
      return response.data;
    } catch (error) {
      console.error("There was an error fetching the data", error);
      throw error;
    }
  }

  async addNewData(name: string): Promise<Users> {
    try {
      const response = await axios.post<Users>(`${BASE_URL}postData.php`, {
        name,
      });
      return response.data;
    } catch (error) {
      console.error("There was an error adding the item", error);
      throw error;
    }
  }
}
